import { all, call } from "redux-saga/effects";
import { watchSearchCityBound, watchSearchAreaBound } from "./maps";

import {
  watchPublishCity,
  watchPublishGeofence,
  watchSelectCity,
  watchPublishSelectedIdFence,
  watchDeleteSelectedIdFence,
  watchFetchCities,
  watchFetchOrderLocs,
  watchAdditionalCity
} from "./city";

import {
  watchSetWarehouseSearch,
  watchViewAssignedWarehouseOf,
  watchSetWarehouses,
  watchAssignWarehousesToBuddyBlock,
  watchAssignWarehousesToWarehouseFences
} from "./warehouse";

import {
  watchAuthUserAction,
  watchCheckUserLoggedInAction,
  logoutUserActionWatcher
} from "./user";

export default function* geofenceRootSaga() {
  yield all([
    call(watchSearchCityBound),
    call(watchSearchAreaBound),
    call(watchPublishCity),
    call(watchSelectCity),
    call(watchPublishGeofence),
    call(watchPublishSelectedIdFence),
    call(watchDeleteSelectedIdFence),
    call(watchFetchCities),
    call(watchFetchOrderLocs),
    call(watchAuthUserAction),
    call(watchCheckUserLoggedInAction),
    call(logoutUserActionWatcher),
    call(watchSetWarehouseSearch),
    call(watchViewAssignedWarehouseOf),
    call(watchSetWarehouses),
    call(watchAssignWarehousesToBuddyBlock),
    call(watchAssignWarehousesToWarehouseFences),
    call(watchAdditionalCity)
  ]);
}
